import {
  AlertFilled,
  ArrowUpOutlined,
  FlagTwoTone,
  InteractionTwoTone,
  WarningOutlined,
} from '@ant-design/icons';
import { Col, Row, Tooltip } from 'antd';

import { ISnapStore } from '../../store';

export const SnapIconStatuses = ({
  isSmall,
  claimDetails,
  escalateDetails,
  fraudSuspicionReason,
  claimReferenceCode,
  snapBooleanStatuses,
}: {
  isSmall?: boolean;
  claimDetails?: string;
  escalateDetails?: string;
  fraudSuspicionReason?: string;
  claimReferenceCode?: string;
  snapBooleanStatuses: Pick<ISnapStore['snapBooleanStatuses'], 'isRequiresTroubleshooting' | 'isEscalated' | 'isProcessing' | 'isCollectorFraudster' | 'isFraudSuspicious'>;
}) => {
  const fontSize = isSmall ? 'text-[16px]' : 'text-[20px]';

  return (
    <Row gutter={isSmall ? 6 : 10}>
      {/* value could be false should handle it */}
      {snapBooleanStatuses.isRequiresTroubleshooting !== undefined && (
        <Col>
          <Tooltip
            placement='bottom'
            title={
              snapBooleanStatuses?.isRequiresTroubleshooting
                ? (
                  <>
                    <Row>
                      <strong>Claim ID: </strong>
                      {claimReferenceCode}
                    </Row>
                    {claimDetails}
                  </>
                )
                : 'Claim resolved'
            }
          >
            <FlagTwoTone
              title='Claim'
              className={fontSize}
              twoToneColor={snapBooleanStatuses.isRequiresTroubleshooting ? 'red' : '#bfbfbf'}
            />
          </Tooltip>
        </Col>
      )}

      {snapBooleanStatuses.isEscalated && (
        <Col>
          <Tooltip
            title={escalateDetails}
            placement='bottom'
          >
            <ArrowUpOutlined className={`${fontSize} text-[red]`} />
          </Tooltip>
        </Col>
      )}

      {snapBooleanStatuses?.isCollectorFraudster && (
        <Col>
          <Tooltip
            title='Collector of this snap is fraud'
            placement='bottom'
          >
            <AlertFilled className={fontSize} />
          </Tooltip>
        </Col>
      )}

      {snapBooleanStatuses?.isFraudSuspicious && (
        <Col>
          <Tooltip
            title={fraudSuspicionReason}
            placement='bottom'
          >
            <WarningOutlined className={fontSize} />
          </Tooltip>
        </Col>
      )}

      {snapBooleanStatuses.isProcessing && (
        <Col>
          <Tooltip
            title='In Processing'
            placement='bottom'
          >
            <InteractionTwoTone className={fontSize} />
          </Tooltip>
        </Col>
      )}
    </Row>
  );
};
